import { takeEvery, put } from 'redux-saga/effects';
// action types
import { GET_SUBSCRIPTION } from '../reducers/billing';
// actions
import { setSubscription } from '../reducers/auth';
import { closeModal } from '../reducers/modal';

/* worker-saga */
function* onGetSubscription() {
  yield put(closeModal());
  yield put(setSubscription());
}

/* watcher-saga */
function* watchBillingActions() {
  yield takeEvery(`${GET_SUBSCRIPTION}_SUCCESS`, onGetSubscription);
}

export default watchBillingActions;



// WEBPACK FOOTER //
// ./src/redux/sagas/billing.js